import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Btns, ButtonL, Content, Section, TextDiv } from "../../styles/Common";
import { styled } from "styled-components";
import OnePageLayout from "../../components/layout/OnePageLayout";
import ToAmoComponent from "../../components/amo/ToAmoComponent";
import ToPointComponent from "../../components/amo/ToPointComponent";

const AmoChangeCurrent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const toAmoCoin = location.state !== null ? location.state.toAmoCoin : "";
  return (
    <OnePageLayout title="AMO 포인트 교환">
      {toAmoCoin ? <ToAmoComponent /> : <ToPointComponent />}
    </OnePageLayout>
  );
};

export default AmoChangeCurrent;
